import { PurchaseOrder, Supplier } from "./types"

export enum ActionType {
    UPDATE_PURCHASES = 'updatePurchases',
    REMOVE_PURCHASES = 'removePurchases',
    UPDATE_SUPPLIERS = 'updateSuppliers',
    REMOVE_SUPPLIERS = 'removeSuppliers',
    SET_CURRENT_PURCHASE = 'setCurrentPurchase'
}

interface UpdatePurchases {
    type: ActionType.UPDATE_PURCHASES
    payload: PurchaseOrder[]
}

interface RemovePurchases {
    type: ActionType.REMOVE_PURCHASES
    payload: string[]
}

interface UpdateSuppliers {
    type: ActionType.UPDATE_SUPPLIERS
    payload: Supplier[]
}

interface RemoveSuppliers {
    type: ActionType.REMOVE_SUPPLIERS
    payload: string[]
}

interface SetCurrentPurchase {
    type: ActionType.SET_CURRENT_PURCHASE
    payload: PurchaseOrder
}

export type PurchasesAction =
    SetCurrentPurchase |    
    PurchasesUpdateAction |
    PurchasesRemoveAction

export type PurchasesUpdateAction =
    UpdatePurchases |
    UpdateSuppliers

export type PurchasesRemoveAction =
    RemovePurchases |
    RemoveSuppliers
